<div class="my-auto relative w-full sm:w-60">
    <input
        #searchInput
        matInput
        type="text"
        class="rounded-full bg-primary-100 h-8 w-full px-3 text-tertiary-900 focus:outline-none placeholder-tertiary-600"
        placeholder="Search"
        (input)="input($event)"
        (keydown.enter)="preventEnterSubmit($event)"
    />
    <mat-icon class="absolute right-3 top-1 scale-75 !text-tertiary-900"
        >search</mat-icon
    >
</div>
